import * as React from "react";

import { TimeDisplayMode } from "@/shared/components/visualization/WorkspaceCtx/TimeDisplayMode";

import styles from "./BetweenDateTimeSelector.module.css";
import { DateTimeSelector } from "./DateTimeSelector";

export interface BetweenDateTimeSelectorProps {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
  timeDisplayMode: TimeDisplayMode;
  /** Which tab to show when the component mounts. Defaults to "from". */
  initialTab?: "from" | "to";
  /** When provided, renders a confirm button on the active DateTimeSelector. */
  onConfirm?: () => void;
}

export function BetweenDateTimeSelector({
  from,
  to,
  onChange,
  timeDisplayMode,
  initialTab = "from",
  onConfirm,
}: BetweenDateTimeSelectorProps) {
  const [activeTab, setActiveTab] = React.useState<"from" | "to">(initialTab);

  return (
    <div className={styles.container}>
      <div className={styles.tabRow}>
        <button
          type="button"
          className={styles.tab}
          data-active={activeTab === "from"}
          onClick={() => setActiveTab("from")}
        >
          From
        </button>
        <button
          type="button"
          className={styles.tab}
          data-active={activeTab === "to"}
          onClick={() => setActiveTab("to")}
        >
          To
        </button>
      </div>
      {/* Both selectors stay mounted to avoid re-triggering the
          auto-emit fallback when switching tabs. Visibility is toggled
          with CSS (display:none) instead of conditional rendering. */}
      <div
        className={styles.content}
        style={{ display: activeTab === "from" ? undefined : "none" }}
      >
        <DateTimeSelector
          value={from}
          onChange={(v) => onChange(v, to)}
          timeDisplayMode={timeDisplayMode}
          label="From"
          onConfirm={onConfirm}
        />
      </div>
      <div
        className={styles.content}
        style={{ display: activeTab === "to" ? undefined : "none" }}
      >
        <DateTimeSelector
          value={to}
          onChange={(v) => onChange(from, v)}
          timeDisplayMode={timeDisplayMode}
          label="To"
          onConfirm={onConfirm}
        />
      </div>
    </div>
  );
}
